<template>
  <div class="l-borrow__homepage-container-inner">
    <div class="l-borrow__car-img" :style="{ 'background-image': 'url(' + imageUrl + ')' }">
      <div class="price">€ {{ formattedMax }}</div>
    </div>
    <div class="right-section">
      <div class="l-how-much">
        {{ title }}
        <p>{{ description }}</p>
      </div>
      <div class="l-slider-button" v-if="!serverError">
        <slider
          v-model="amount"
          :max="max"
          :min="minAmount"
          :infoButtonText="sliderLoadButtonText"
          @infoButtonClicked="infoButtonClicked"
        />

        <div class="l-button-container">
          <input
            type="submit"
            class="o-btn"
            :value="buttonText"
            @click="calculateButtonClicked"
          />
          <div class="l-txt-center">{{ buttonSubText }}</div>
        </div>
      </div>
      <div class="error" v-if="serverError">{{ errorText }}</div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import * as Api from "../../api";
import * as BofiUtils from "../../utils";
import Slider from "../slider/slider";

export default {
  name: "LoanCalculateWidget",
  components: {
    Slider,
  },
  props: {
    title: { type: String, required: true },
    descriptionFormat: { type: String, required: true },
    buttonText: { type: String, required: true },
    buttonSubText: { type: String, required: true },
    sliderLoadButtonText: { type: String, required: true },
    errorText: { type: String, required: true },
    minAmount: { type: Number, default: 2250 },
  },
  data() {
    return {
      min: 2250,
      max: 2250,
      amount: 0,
      imageUrl: "",
      serverError: undefined,
      requestBaseUrl: "/page/BOFI_REQUEST",
      infoMediaItemId: undefined,
    };
  },
  beforeMount: function() {
    Api.Credit.getCalculationData()
      .then(data => {
        this.amount = this.minAmount;
        this.max = data.price;
        this.imageUrl = data.imageUrl;
      })
      .catch(() => {
        this.serverError = true;
      });

    Api.Credit.getBofiArticleInfo("BOFI_LOAN_INFO")
      .then(info => {
        this.infoMediaItemId = info.id;
      })
      .catch(() => {
        this.serverError = true;
      });
  },
  computed: {
    formattedMax() {
      return BofiUtils.formatMoney(this.max);
    },
    description() {
      return this.descriptionFormat.replace("{price}", this.formattedMax);
    },
  },
  methods: {
    calculateButtonClicked() {
      location.assign(`${this.requestBaseUrl}?loan=${this.amount}`);
    },
    infoButtonClicked() {
      $(`[data-target="modal-${this.infoMediaItemId}"]`).click();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@bvm/bofi/src/assets/scss/settings/_settings.scss";

.l-txt-center {
  text-align: center;
  font-family: Lato;
  font-size: rem-calc(14);
  padding-top: 15px;
  line-height: 20px;
  color: $color-grey;

  @include for-size(tablet-portrait-up) {
    margin-top: -11px;
  }

  @include for-size(desktop-up) {
    margin-top: -10px;
    font-size: 14px;
    line-height: 20px;
  }
}

.l-slider-button {
  margin: 0 3px;
}

.l-button-container .o-btn {

  @include for-size(tablet-portrait-up) {
    margin-left: 5px;
  }

  @include for-size(desktop-up) {
    margin-left: 10px;
  }

  margin-top: 10px;
  max-width: 100%;
}

.l-how-much {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 20px;
  color: $color-black;

  @include for-size(tablet-portrait-up) {
    font-size: 24px;

    p {
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      padding-top: 5px;
      margin-bottom: 0;
    }

    .o-tooltip {
      display: none;
    }
  }
}

.error {
  margin-top: 20px;
  color: red;
}
</style>
